import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AppProvider } from "./context/AppContext";
import AppShell from "./components/layout/AppShell";
import { RequireMenu } from "./components/layout/RequireMenu";
import ResetPassword from "./pages/ResetPassword";
import Lockdown from "./pages/Lockdown";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Records from "./pages/Records";
import RecordDetail from "./pages/RecordDetail";
import ReviewQueue from "./pages/ReviewQueue";
import ReviewWorkspace from "./pages/ReviewWorkspace";
import Requests from "./pages/Requests";
import Reports from "./pages/Reports";
import AuditLog from "./pages/AuditLog";
import ApiClients from "./pages/ApiClients";
import Settings from "./pages/Settings";
import Help from "./pages/Help";
import FieldLibrary from "./pages/config/FieldLibrary";
import DocumentLibrary from "./pages/config/DocumentLibrary";
import Classes from "./pages/config/Classes";
import ClassDetail from "./pages/config/ClassDetail";
import PublicRequest from "./pages/PublicRequest";
import Landing from "./pages/Landing";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/account/lockdown" element={<Lockdown />} />
            <Route path="/request/:token" element={<PublicRequest />} />
            <Route element={<AppShell />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/records" element={<RequireMenu menu="records"><Records /></RequireMenu>} />
              <Route path="/records/:id" element={<RequireMenu menu="records"><RecordDetail /></RequireMenu>} />
              <Route path="/review" element={<RequireMenu menu="review"><ReviewQueue /></RequireMenu>} />
              <Route path="/review/:id" element={<RequireMenu menu="review"><ReviewWorkspace /></RequireMenu>} />
              <Route path="/requests" element={<RequireMenu menu="requests"><Requests /></RequireMenu>} />
              <Route path="/reports" element={<RequireMenu menu="reports"><Reports /></RequireMenu>} />
              <Route path="/audit" element={<RequireMenu menu="audit"><AuditLog /></RequireMenu>} />
              <Route path="/integrations" element={<RequireMenu menu="integrations"><ApiClients /></RequireMenu>} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/help" element={<Help />} />
              <Route path="/settings/:tab" element={<Settings />} />
              <Route path="/config/fields" element={<RequireMenu menu="fields"><FieldLibrary /></RequireMenu>} />
              <Route path="/config/documents" element={<RequireMenu menu="documents"><DocumentLibrary /></RequireMenu>} />
              <Route path="/config/classes" element={<RequireMenu menu="classes"><Classes /></RequireMenu>} />
              <Route path="/config/classes/:id" element={<RequireMenu menu="classes"><ClassDetail /></RequireMenu>} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AppProvider>
    </div>
  );
}

export default App;
